import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function(element) {
    if (document.querySelector('#scroll-slider')) {
        document.addEventListener('sliderReady', () => {
            animations();
        });
    } else {
        animations();
    }

    function animations () {
        gsap.fromTo(element.querySelectorAll(".use__item_1 .grass-1, .use__item_1 .grass-2, .use__item_1 .grass-3"),
            { 
                x: (i) => i === 2 ? -40 : 40,
                y: 10,
                scale: 0.6,
                opacity: 0
            },
            { 
                x: 0,
                y: 0,
                scale: 1,
                opacity: 1,
                duration: 1,
                ease: "power4.out",
                stagger: 0.2,
                scrollTrigger: {
                    trigger: element,
                    start: "top bottom-=30%",
                    toggleActions: "play reverse play reverse",
                    // markers: true
                }
            }
        );
    
        gsap.fromTo(element.querySelectorAll(".use__item_2 .grass-1, .use__item_2 .grass-2, .use__item_2 .grass-3"),
            { 
                x: (i) => i === 1 ? -20 : 40,
                y: (i) => i == 2 ? -10 : 30,
                scale: 0.6,
                opacity: 0
            },
            { 
                x: 0,
                y: 0,
                scale: 1,
                opacity: 1,
                duration: 1,
                ease: "power4.out",
                stagger: 0.2,
                scrollTrigger: {
                    trigger: element,
                    start: "top bottom-=30%",
                    toggleActions: "play reverse play reverse",
                    // markers: true
                }
            }
        );
    }
};